<template>
  <div>
    <DialogContainer v-model="dialogObj">
      <template v-slot:dialogSlot>
        <div class="business-body custom-form">
          <div class="list-status">
            <div class="list-carInfo">
              <div class="title-box">
                <el-image :src="carImage" class="title-label"></el-image>
                司机信息
              </div>
              <div class="list-box">
                <div class="list-bottom">
                  <div class="list-bottom-box">
                    <div class="bottom-box-name">司机姓名</div>
                    <div class="bottom-box-value">{{ detail.username }}</div>
                  </div>
                  <div class="list-bottom-box ">
                    <div class="bottom-box-name">司机联系方式</div>
                    <div class="bottom-box-value">{{ detail.phone }}</div>
                  </div>
                  <div class="list-bottom-box ">
                    <div class="bottom-box-name">车牌号码</div>
                    <div class="bottom-box-value">{{ detail.carNumber }}</div>
                  </div>
                  <div class="list-bottom-box">
                    <div class="bottom-box-name">运输路线</div>
                    <div class="bottom-box-value">{{detail.startCityName}} - {{detail.endCityName}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 日历 -->
          <div v-loading="loading" style="position:relative;">
            <div class="dot-detail">
              <div class="detail-box">
                <span class="label-text">出勤</span>
                <span class="value-text">{{scheduleData.dutyDays}}天</span>
              </div>
              <div class="detail-box">
                <span class="label-text">不出勤</span>
                <span class="value-text">{{scheduleData.notDutyDays}}天</span>
              </div>
              <div class="detail-box">
                <span class="label-text">未排班</span>
                <span class="value-text">{{scheduleData.unSchedulingDays}}天</span>
              </div>
            </div>
            <el-calendar v-model="currentDate">
              <template slot="dateCell" slot-scope="{ date }">
                <div
                  class="calendar-day"
                  :class="{
                    disabled: !isCurrentMonth(date),
                    'before-today': isBeforeToday(date)
                  }"
                  @click="isBeforeToday(date)?'':handleDayClick(date)"
                >
                  <div class="day-num">{{ date.getDate() }}</div>
                  <div class="status" :class="getStatusClass(date)">
                    {{ getStatusText(date) }}
                  </div>
                  <!--<div v-if="getDispatcherName(date)" class="dispatch">派单调度：{{ getDispatcherName(date) }}</div>-->
                </div>
              </template>
            </el-calendar>
          </div>
        </div>
      </template>
    </DialogContainer>
    <addOrEdit ref="addOrEdit"></addOrEdit>
  </div>
</template>

<script>
import addOrEdit from "./addOrEdit.vue";
import DialogContainer from "@/components/Dialog.vue";
import {getDriverScheduling, schedulingDriver} from "./api";
import dayjs from "dayjs"
export default {
  name: "AddOrEdit",
  components: {
    DialogContainer,
    addOrEdit,
  },
  data() {
    return {
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "60%",
        show: false,
        title: "司机排班",
        closeOnClickModal: false,
        confirmFn: "",
        beforeClose: (v) => {
          this.currentDate = ""
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      currentDate: "",
      saveDate: "",
      detail: {},
      carImage: require("@/assets/imgs/title.png"),
      scheduleData: {},
      loading: false,
      show: false
    };
  },
  mounted() {

  },
  methods: {
    handleAddOrEditSuccess() {
      this.getDetail(this.saveDate)
    },
    // 判断是否当前月份
    isCurrentMonth(date) {
      const current = new Date(this.currentDate);
      return (
          date.getFullYear() === current.getFullYear() &&
          date.getMonth() === current.getMonth()
      );
    },
    // 点击处理：非当月直接 return
    handleDayClick(date) {
      if (!this.isCurrentMonth(date)) return;
      const dateStr = date.toISOString().split("T")[0];
      // // console.log("点击当月日期：", dateStr);
      // if (this.isBeforeToday(dateStr)) {
      //   return;
      // } else {
        // // // console.log("this.detailthis.detailthis.detailthis.detail", this.detail);
        this.$refs.addOrEdit.init(this.getScheduleItem(dateStr), this.detail.driverId, this.scheduleData.dispatcherId);
      // }
      // 你自己的业务逻辑
    },
    getScheduleItem(date) {
      // 1. 把传入的日期统一转成 YYYY-MM-DD 格式
      const targetDate = dayjs(date).format('YYYY-MM-DD')

      // 2. 从你的排班列表里查找匹配项
      const list = this.scheduleData?.schedulingList || []

      // 3. 返回找到的那一项（没有就返回 null）
      return list.find(item => item.scheduledDate === targetDate)
    },
    //
    isBeforeToday(targetDate) {
      const target = dayjs(targetDate).startOf('day')
      const today = dayjs().startOf('day')
      return target < today
    },
    // 获取排班
    getSchedule(date) {
      if (!this.isCurrentMonth(date)) return null;
      const dateStr = date.toISOString().split("T")[0];
      return this.scheduleData.schedulingList.find(
          (item) => item.scheduledDate === dateStr
      );
    },
    // 状态样式
    getStatusClass(date) {
      const s = this.getSchedule(date);
      if (!s) return "default";
      if (s.schedulingStatus === 0) return "wait";
      if (s.schedulingStatus === 1) return "work";
      if (s.schedulingStatus === 2) return "rest";
      return "default";
    },
    // 状态文字
    getStatusText(date) {
      const s = this.getSchedule(date);
      if (!s) return "";
      if (s.schedulingStatus === 0) return "未排班";
      if (s.schedulingStatus === 1) return "出勤";
      if (s.schedulingStatus === 2) return "不出勤";
      return "";
    },
    // 调度人员
    getDispatcherName(date) {
      const s = this.getSchedule(date);
      return s?.orderDispatcherName || "";
    },
    async init(row) {
      this.detail = Object.assign({}, row);
      this.currentDate = new Date();
      let date = dayjs().format('YYYY-MM')
      this.dialogObj.show = true;
      await this.getDetail(date);



      this.$nextTick(() => {
        // 点击前一个月
        let prevBtn = document.querySelector(
            ".el-calendar__button-group .el-button-group>button:nth-child(1)"
        );
        prevBtn.addEventListener("click", e => {
          const current = new Date(this.currentDate);
          let year = current.getFullYear();
          let month = current.getMonth() + 1;
          if (month < 10) month = "0" + month;
          let date = year + '-' + month
          // // console.log("11", date);
          this.getDetail(date)
        })
        //点击下一个月
        let nextBtn = document.querySelector(
            ".el-calendar__button-group .el-button-group>button:nth-child(3)"
        );
        nextBtn.addEventListener("click", () => {
          const current = new Date(this.currentDate);
          let year = current.getFullYear();
          let month = current.getMonth() + 1;
          if (month < 10) month = "0" + month;
          let date = year + '-' + month
          // // console.log("22", date);
          this.getDetail(date)
        });

        //点击今天
        let todayBtn = document.querySelector(
            ".el-calendar__button-group .el-button-group>button:nth-child(2)"
        );
        todayBtn.addEventListener("click", () => {
          const current = new Date(this.currentDate);
          let year = current.getFullYear();
          let month = current.getMonth() + 1;
          if (month < 10) month = "0" + month;
          let date = year + '-' + month
          // // console.log("33", date);
          this.getDetail(date)
        });

      })
    },
    getDetail(date) {
      this.loading = true
      this.saveDate = date
      getDriverScheduling({
        driverId: this.detail.driverId,
        month: date,
      }).then((res) => {
        if (res.code === 200) {
         this.scheduleData = res.data;
        }
      }).finally(()=>{
        this.loading = false
      })
    },
    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          const par = {
            schedulingDate: this.form.schedulingDate,
            driverId: this.form.driverId,
            schedulingStatus: this.form.schedulingStatus,
          };
          schedulingDriver(par)
              .then((res) => {
                this.dialogObj.btnLoading = false;
                if (res.code === 200) {
                  this.$message.success("排班成功");
                  this.$parent.handleAddOrEditSuccess("edit");
                  this.dialogObj.beforeClose();
                }
              })
              .catch((e) => {
                this.dialogObj.btnLoading = false;
              });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .left-box {
    padding-right: 0.5rem;
    padding-bottom: 0.1rem;
    position: relative;
    display: flex;
    align-items: center;
    .left-box-top {
      display: flex;
      align-items: center;
      .label {
        width: 0.2rem;
        height: 0.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0.02rem;
        font-size: 0.12rem;
      }
      .zhuang {
        color: #5cc41a;
        background-color: rgba(92, 196, 26, 0.3);
      }
      .xie {
        color: #e52019;
        background-color: rgba(229, 32, 25, 0.3);
      }
      .name {
        color: #000000;
        font-size: 0.18rem;
        line-height: 0.2rem;
        padding-left: 0.04rem;
      }
    }
    .date {
      color: #8c8c8c;
      font-size: 0.12rem;
      line-height: 0.2rem;
    }
  }
  .left-box:nth-last-of-type(1)::before {
    display: none;
  }
  .car-img {
    width: 0.1rem;
    height: 0.1rem;
    margin-right: 0.04rem;
  }
  .center-box-2 {
    display: flex;
    align-items: center;
    line-height: 0.24rem;
    color: #000000;
    font-size: 0.12rem;
    position: relative;
  }
  .center-box-2 {
    padding-left: 0.2rem;
    position: relative;
    &::before {
      content: "";
      width: 0.01rem;
      height: 0.1rem;
      background-color: #dce5f5;
      position: absolute;
      left: 0.1rem;
    }
  }
  .center-box-1 {
    color: #1269ff;
  }
}
.list-box {
  background: #f7fbff;
  border-radius: 0.08rem;
  padding: 0.1rem;
  box-sizing: border-box;
  margin-top: 0.2rem;
  .list-bottom {
    width: 100%;
    display: flex;
    padding: 0.08rem 0;
    .list-bottom-box {
      width: 25%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      .list-image {
        width: 0.85rem;
        height: 0.5rem;
        border-radius: 0.05rem;
      }
      .bottom-box-name {
        color: #8c8c8c;
        font-size: 0.12rem;
        margin-bottom: 0.06rem;
      }
      .bottom-box-value {
        color: #434343;
        text-align: center !important;
        font-size: 0.14rem;
      }
    }
    .list-bottom-box2 {
      width: 20%;
    }
    .list-bottom-box::before {
      content: "";
      position: absolute;
      right: 0;
      top: 0.08rem;
      width: 0.01rem;
      height: 0.26rem;
      background-color: #dce5f5;
    }
    .list-bottom-box:nth-last-of-type(1)::before {
      display: none;
    }
  }
  .list-bottom2 {
    .list-bottom-box:nth-last-of-type(1):before,
    .list-bottom-box:nth-last-of-type(2):before,
    .list-bottom-box:nth-last-of-type(3):before,
    .list-bottom-box:nth-last-of-type(4):before {
      display: none;
    }
  }
}
.list-status {
  display: flex;
  .title-box {
    padding: 0.2rem 0 0;
    .title-label {
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.06rem;
    }
  }
  .list-step {
    width: 25%;
  }
  .list-carInfo {
    width: 100%;
  }
  .list-label {
    padding: 0.1rem 0;
  }
  //.list-step-box {
  //  display: flex;
  //  flex-direction: column;
  //  padding: 0 0.3rem 0 0.5rem;
  //  box-sizing: border-box;
  //  .step-list {
  //    border-radius: 0.1rem;
  //    background: #ffffff;
  //    padding: 0.04rem 0.14rem;
  //    box-sizing: border-box;
  //    margin-bottom: 0.5rem;
  //    position: relative;
  //    .step-date {
  //      font-size: 0.12rem;
  //      height: 0.22rem;
  //    }
  //    .step-content {
  //      font-size: 0.14rem;
  //    }
  //  }
  //  .step-list::before {
  //    content: "";
  //    position: absolute;
  //  }
  //}
  .color8c8c8c {
    color: #8c8c8c;
  }
  .color434343 {
    color: #434343;
  }
  .bgEDF4FF {
    background-color: #edf4ff;
  }
}
.schedule-container {
  padding: 20px;
}
.stats-wrapper {
  margin-bottom: 15px;
}
.stats-wrapper .el-tag {
  margin-right: 10px;
}
.calendar-day {
  width: 100%;
  height: 100%;
  text-align: center;
  padding: 2px 0;
  cursor: pointer;
  &.before-today {
    background: rgba(0,0,0,0.1); // 置灰背景
    color: #c0c0c0;      // 文字变浅灰
    //pointer-events: none; // 可选：禁止点击过去日期
    .status {
      color: #ffffff;
    }
  }
}
/* 非当月：置灰 + 禁止点击 */
.calendar-day.disabled {
  opacity: 0;
  pointer-events: none;
  background: #f5f5f5;
}
.day-num {
  font-weight: bold;
  margin-bottom: 4px;
}
.status {
  display: inline-block;
  padding: 1px 4px;
  font-size: 11px;
  color: #fff;
  border-radius: 3px;
  margin-bottom: 3px;
}
.dispatch {
  font-size: 10px;
  color: #666;
  padding-top: 6px;
}
.wait { background: #e6a23c; }
.work { background: #67c23a; }
.rest { background: #f56c6c; }
.default { background: #eee; }
::v-deep .el-calendar {
  .el-calendar-table{
    width: 100%;
    height: 100%;
    &:not(.is-range){
      td.next{
        pointer-events: none;
      }
      td.prev{
        pointer-events: none;
      }
    }
  }
}
.dot-detail{
  display: flex;
  align-items: center;
  position: absolute;
  top: 15px;
  left: 50%;
  transform: translateX(-50%);
  .detail-box{
    margin-right: 10px;
    .label-text{
      color: #fff;
      border-radius: 2px;
      padding: 2px 4px;
    }
    .value-text{
      font-size: 16px;
      padding-left: 10px;
    }
  }
  .detail-box:nth-of-type(1){
    .label-text{
      background: #67c23a;
    }
  }
  .detail-box:nth-of-type(2){
    .label-text{
      background: #f56c6c;
    }
  }
  .detail-box:nth-of-type(3){
    .label-text{
      background: #e6a23c;
    }
  }
}
::v-deep .el-button-group{
  .el-button:nth-of-type(2){
    display: none;
  }
}
</style>
